import React from 'react';
import PropTypes from 'prop-types';
import BaseComp from './baseComp';
import emptyImg from './empty.png';

class LazyImgOrigin extends BaseComp {
    static propTypes = {
        placeholder: PropTypes.string.isRequired,
        src: PropTypes.string.isRequired,
        observer: PropTypes.object.isRequired,
        event: PropTypes.object.isRequired,
        loadCallback: PropTypes.func,
    };

    static defaultProps = {
        placeholder: emptyImg,
    };

    render() {
        const { placeholder, src } = this.props;
        const { isLoaded } = this.state;
        const imgSrc = isLoaded ? src : placeholder;
        const imgProps = { ...this.props, src: imgSrc };

        delete imgProps.observer;
        delete imgProps.event;
        delete imgProps.placeholder;
        delete imgProps.loadCallback;
        delete imgProps.loadData;

        return <img {...imgProps} />;
    }
}

export default LazyImgOrigin;
